import React, { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import MyImage from "../../../assets/images/myImage.jpg";
import classes from "./IntroCard.module.css";

const IntroCard = () => {
  const containerRef = useRef(null);

  const { scrollYProgress } = useScroll({
    target: containerRef,
    offset: ["start start", "end start"],
  });

  // Image moves down slower than scroll (parallax)
  const imageY = useTransform(scrollYProgress, [0, 1], [0, 120]);
  // Image scales down slightly as you scroll
  const imageScale = useTransform(scrollYProgress, [0, 1], [1, 0.9]);
  // Image opacity fades out gently
  const imageOpacity = useTransform(scrollYProgress, [0, 0.8], [1, 0.3]);
  // Text moves up slightly faster than scroll
  const textY = useTransform(scrollYProgress, [0, 1], [0, -40]);
  // Subtle rotation on the image
  const imageRotate = useTransform(scrollYProgress, [0, 1], [0, 3]);

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.3,
        delayChildren: 0.2,
      },
    },
  };

  const textVariants = {
    hidden: { opacity: 0, x: -50 },
    visible: {
      opacity: 1,
      x: 0,
      transition: { duration: 0.8, ease: "easeOut" },
    },
  };

  const imageVariants = {
    hidden: { opacity: 0, x: 50, scale: 0.9 },
    visible: {
      opacity: 1,
      x: 0,
      scale: 1,
      transition: { duration: 0.8, ease: "easeOut" },
    },
  };

  return (
    <motion.div
      className={classes.IntroCard}
      ref={containerRef}
      variants={containerVariants}
      initial="hidden"
      animate="visible"
    >
      <motion.div className={classes.IntroCardWriteUp} variants={textVariants} style={{ y: textY }}>
        <motion.p
          className={classes.IntroName}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3, duration: 0.6 }}
        >
          Hello, I'm James
        </motion.p>
        <motion.p
          className={classes.IntroText}
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.5, duration: 0.8 }}
        >
         I’m a results-driven web developer who turns ideas into reliable, high-performing digital products. I don’t just write code—I solve problems, build with purpose, and create web experiences that help businesses grow. From concept to execution, I bring the technical expertise and entrepreneurial mindset to turn complex challenges into scalable solutions.
        </motion.p>
      </motion.div>

      <motion.div className={classes.MyImageDiv} variants={imageVariants}>
        <motion.div
          className={classes.ImageGlow}
          style={{ y: imageY }}
        />
        <motion.img
          src={MyImage}
          alt="James"
          style={{
            y: imageY,
            scale: imageScale,
            opacity: imageOpacity,
            rotate: imageRotate,
          }}
          whileHover={{ scale: 1.03 }}
          transition={{ duration: 0.3 }}
        />
      </motion.div>
    </motion.div>
  );
};

export default IntroCard;
